import router from './router';
import ROUTE_NAMES from './route-names';

export default router;
export { ROUTE_NAMES };
